import { useEffect } from 'react';

export const useStructuredData = (data: object) => {
  useEffect(() => {
    const script = document.createElement('script');
    script.type = 'application/ld+json';
    script.id = 'page-structured-data';
    script.text = JSON.stringify(data);
    document.head.appendChild(script);

    return () => {
      document.getElementById('page-structured-data')?.remove();
    };
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
};
